"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Button_scss_1 = __importDefault(require("./Button.scss"));
var DropDownItem_scss_1 = __importDefault(require("./DropDownItem.scss"));
var layout_1 = require("../layout");
var Dropdown = function (_a) {
    var _b, _c;
    var children = _a.children, onClick = _a.onClick, props = __rest(_a, ["children", "onClick"]);
    var groupCtx = (0, react_1.useContext)(layout_1.GroupContext);
    var _d = (0, react_1.useState)(false), show = _d[0], setShow = _d[1];
    var buttonRef = (0, react_1.useRef)(null);
    var splitButtonRef = (0, react_1.useRef)(null);
    var containerRef = (0, react_1.useRef)(null);
    var isSplit = onClick ? true : false;
    var handClick = function (e) {
        var _a, _b, _c;
        var kbEvent = e;
        if (((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) || ((_b = splitButtonRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target))) {
            return;
        }
        if (kbEvent.key == 'Tab') {
            if ((_c = containerRef.current) === null || _c === void 0 ? void 0 : _c.contains(kbEvent.target)) {
                return;
            }
        }
        setShow(false);
    };
    (0, react_1.useEffect)(function () {
        ['click', 'touchstart', 'keyup'].forEach(function (event) { return document.addEventListener(event, handClick, true); });
        return function () {
            ['click', 'touchstart', 'keyup'].forEach(function (event) { return document.removeEventListener(event, handClick, true); });
        };
    }, []);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('btn-group', { show: show }) },
        react_1.default.createElement("button", { id: props.id ? props.id : undefined, className: (0, classnames_1.default)(Button_scss_1.default['au-btn'], (_b = {},
                _b[Button_scss_1.default['au-btn--secondary']] = props.mode == 'secondary',
                _b[Button_scss_1.default['au-btn--block']] = props.size == 'block',
                _b['dropdown-toggle'] = !isSplit,
                _b), groupCtx.className, props.className), onClick: function () {
                if (onClick)
                    onClick();
                else
                    setShow(!show);
            }, disabled: props.disabled, "aria-labelledby": props.describedBy || '', title: props.title || undefined, role: "button", "aria-haspopup": "true", "aria-expanded": "false", ref: buttonRef }, props.label),
        isSplit ? (react_1.default.createElement("button", { type: "button", className: (0, classnames_1.default)(Button_scss_1.default['au-btn'], (_c = {},
                _c[Button_scss_1.default['au-btn--secondary']] = props.mode == 'secondary',
                _c), "dropdown-toggle", "dropdown-toggle-split"), disabled: props.disabled, "aria-haspopup": "true", "aria-expanded": "false", style: { padding: '8px 18px', zIndex: 0, marginLeft: 1, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }, onClick: function () {
                console.log(show);
                setShow(!show);
            }, ref: splitButtonRef },
            react_1.default.createElement("span", { className: "sr-only" }, "Toggle Dropdown"))) : (react_1.default.createElement(react_1.default.Fragment, null)),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('dropdown-menu', { show: show }, DropDownItem_scss_1.default['au-dropdownmenu']), "aria-labelledby": "dropdownMenuLink", ref: containerRef, style: isSplit ? { left: 'auto', right: 0 } : {} }, children)));
};
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map